export default __webpack_public_path__ + "static/media/DarkRecycleDelete.da98a7fe.svg";